const crakIds = {
  GENERIC_TEXT: '9193680b-a46d-4567-bc54-b7be930b4d84',
  GENERIC_MEDIA: 'add3bf78-9ab1-4170-a6df-49a57910cf6a',
  TERMS_AND_CONDITIONS_INPUT: 'ae086332-0e6d-4a56-bfff-d0a622ca8c36',
  SIGNATURE: 'dccad9c9-6e3d-4ef6-8646-e4c7b06f40ec',
  GENERIC_CHECKBOX: 'dd3e9304-4c52-4931-bd5f-fed2f8337a87',
  JOB_TITLE: '61e6bbcb-3436-4a03-a7c7-86f9193c3d5a',
  COUNTRY: '0b5c3a21-3376-4fea-94d0-bdd9c90452ed',
  COMPANY: '1512b2b6-da57-4b6b-be7b-f29b5cb650e7',
  CUSTOM_TEXT: '9193680b-a46d-4567-bc54-b7be930b4d84'
};

export default crakIds;



// WEBPACK FOOTER //
// ./src/constants/crak.js